(<template>
    <div :class="styleClass">
      <h1 id="title-new-walk" v-if="!loadedForm" v-translate>Add new themed walk</h1>
      <h1 id="title-edit-walk" v-else v-translate>Edit themed walk</h1>
      <el-form :model="walkForm"
               :rules="rules"
               ref="walkForm"
               label-position="left"
               label-width="12em">
        <el-form-item prop="title">
          <span slot="label" v-translate>Title</span>
          <el-input id="input-title"
                    :placeholder="titlePlaceholder.hu"
                    v-model="walkForm.title.hu"
                    @focus="showName=true"></el-input>
          <el-collapse-transition>
            <div v-show="showName">
              <el-input id="input-title-en"
                        class="input-style"
                        :placeholder="titlePlaceholder.en"
                        v-model="walkForm.title.en"></el-input><br />
              <el-input id="input-title-ro"
                        class="input-style"
                        :placeholder="titlePlaceholder.ro"
                        v-model="walkForm.title.ro"></el-input>
            </div>
          </el-collapse-transition>
        </el-form-item>
        <el-form-item prop="subtitle">
          <span slot="label" v-translate>Subtitle</span>
          <el-input id="input-subtitle"
                    :placeholder="subtitlePlaceholder.hu"
                    v-model="walkForm.subtitle.hu"
                    @focus="showName=true"></el-input>
          <el-collapse-transition>
            <div v-show="showName">
              <el-input id="input-subtitle-en"
                        class="input-style"
                        :placeholder="subtitlePlaceholder.en"
                        v-model="walkForm.subtitle.en"></el-input><br />
              <el-input id="input-subtitle-ro"
                        class="input-style"
                        :placeholder="subtitlePlaceholder.ro"
                        v-model="walkForm.subtitle.ro"></el-input>
            </div>
          </el-collapse-transition>
        </el-form-item>      
        <el-form-item prop="description">
          <span slot="label" v-translate>Description</span>
          <el-input id="input-desciption"
                    type="textarea"
                    :placeholder="descPlaceholder.hu"
                    v-model="walkForm.description.hu"
                    @focus="showDesc=true"></el-input>
          <el-collapse-transition>
            <div v-show="showDesc">
              <el-input id="input-desciption-en"
                        class="input-style"
                        type="textarea"
                        :placeholder="descPlaceholder.en"
                        v-model="walkForm.description.en"></el-input>
              <el-input id="input-desciption-ro"
                        class="input-style"
                        type="textarea"
                        :placeholder="descPlaceholder.ro"
                        v-model="walkForm.description.ro"></el-input>
            </div>
          </el-collapse-transition>
        </el-form-item> 
        <el-form-item prop="images">
          <span slot="label" v-translate>Images</span>
          <image-uploader :images="walkForm.images"
                          @image-added="addImage"
                          @image-removed="removeImage"></image-uploader>
        </el-form-item>
        <el-form-item>
          <el-button v-if="loadedForm" @click="cancel">
            <span v-if="loadedForm" v-translate>Cancel</span>
          </el-button>
          <el-button id="button-upload" type="primary" @click="submitForm('walkForm')">
            <span v-if="loadedForm" v-translate>Update</span>
            <span v-else v-translate>Upload</span>
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </template>)
  
  (<script>
  import axios from 'axios'
  import ImageUploader from './Image-Uploader.vue'
  
  export default {
    name: 'walk-upload-form',
    components: {
      'image-uploader': ImageUploader
    },
    props: ['loaded-form'],
    beforeRouteEnter (to, from, next) {
      next(vm => {
        if (vm.$session.exists()) {
          next()
        } else {
          next('/signin')
        }
      })
    },
    data () {
      var styleClass = this.loadedForm ? 'update-form' : 'form'
      var walkForm = this.loadedForm || {
        title: {
          hu: '',
          en: '',
          ro: ''
        },
        subtitle: {
          hu: '',
          en: '',
          ro: ''
        },
        description: {
          hu: '',
          en: '',
          ro: ''
        },
        images: []
      }
      walkForm.removedImages = []
      walkForm.newImages = []
      return {
        titlePlaceholder: {
          hu: this.$gettext('Title in Hungarian'),
          en: this.$gettext('Title in English'),
          ro: this.$gettext('Title in Romanian')
        },
        subtitlePlaceholder: {
          hu: this.$gettext('Subtitle in Hungarian'),
          en: this.$gettext('Subtitle in English'),
          ro: this.$gettext('Subtitle in Romanian')
        },
        descPlaceholder: {
          hu: this.$gettext('Description in Hungarian'),
          en: this.$gettext('Description in English'),
          ro: this.$gettext('Description in Romanian')
        },
        styleClass,
        showName: false,
        showDesc: false,
        walkForm,
        rules: {
          title: {
            type: 'object',
            required: true,
            fields: {
              hu: {type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add title')},
              en: {type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add title')},
              ro: {type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add title')}
            }
          },
          subtitle: {
            type: 'object',
            required: true,
            fields: {
              hu: {type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add subtitle')},
              en: {type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add subtitle')},
              ro: {type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add subtitle')}
            }
          },
          description: {
            type: 'object',
            required: true,
            fields: {
              hu: [
                {type: 'string', required: true, message: this.$gettext('Please add description')},
                { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }
              ],
              en: [
                {type: 'string', required: true, message: this.$gettext('Please add description')},
                { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }
              ],
              ro: [
                {type: 'string', required: true, message: this.$gettext('Please add description')},
                { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }
              ]
            }
          },
          images: {
            type: 'array',
            required: true,
            message: this.$gettext('Please add images')
          }
        }
      }
    },
    methods: {
      substract (a, b) {
        return a.filter(element => b.indexOf(element) < 0)
      },
      uploadForm () {
        axios({
          method: 'post',
          url: `${process.env.SERVER_URL}/walks`,
          headers: {'Content-Type': 'application/json'},
          data: this.walkForm,
          withCredentials: true
        })
        .then(response => {
          this.$message({
            type: 'success',
            message: response.data || response.statusText
          })
          this.$router.push('/walks/list')
        })
        .catch(error => {
          var msg
          if (error.response) {
            msg = error.response.data || error.response.statusText
          } else {
            msg = error.message
          }
          this.$message({
            type: 'error',
            message: msg
          })
        })
      },
      updateForm () {
        axios({
          method: 'put',
          url: `${process.env.SERVER_URL}/walks/${this.walkForm.id}`,
          headers: {'Content-Type': 'application/json'},
          data: this.walkForm,
          withCredentials: true
        })
        .then(response => {
          this.$message({
            type: 'success',
            message: response.data || response.statusText
          })
          this.$emit('close-edit')
        })
        .catch(error => {
          var msg
          if (error.response) {
            msg = error.response.data || error.response.statusText
          } else {
            msg = error.message
          }
          this.$message({
            type: 'error',
            message: msg
          })
        })
      },
      cancel () {
        this.$confirm(this.$gettext('Are you sure to close?'), {
          confirmButtonText: this.$gettext('Yes'),
          cancelButtonText: this.$gettext('No'),
          type: 'warning'
        }).then(() => {
          this.$emit('close-edit')
        }).catch(() => {})
      },
      addImage (imageFileName) {
        this.walkForm.newImages.push(imageFileName)
        this.walkForm.images.push(imageFileName)
      },
      removeImage (imageFileName) {
        this.walkForm.removedImages.push(imageFileName)
        this.walkForm.images.splice(this.walkForm.images.indexOf(imageFileName), 1)
        this.walkForm.newImages.splice(this.walkForm.newImages.indexOf(imageFileName), 1)
      },
      submitForm (formName) {
        if (this.walkForm.images.length === 0) {
          this.walkForm.images = [].concat(this.walkForm.newImages)
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.loadedForm) {
              this.updateForm()
            } else {
              this.uploadForm()
            }
          }
        })
      }
    }
  }
  </script>)
  
  (<style>
  .input-style {
    margin-top: 1%;
  }
  .update-form {
    padding: 5%;
  }
  .url-component {
    max-height: 250px;
    width: 100%;
  }
  </style>)
  


// WEBPACK FOOTER //
// src/components/Walk-Upload-Form.vue